export default __webpack_public_path__ + "static/IFP-redesign-61528109787c168afa45499abbd2b007.png";